import { useFetch } from "../../../hooks/Fetching";

export default function useGetConvos(shouldFetch = true) {
  const path = `/inbox/conversations/all`;
  const fetchEnabled = shouldFetch;
  const { data, isLoading, error } = useFetch(
    path,
    null,
    ["conversations"],
    fetchEnabled,
  );

  return { data, isLoading, error };
}
